/*jshint esversion: 9 */
import React from "react";
import { Fragment } from "react";
import { connect } from "react-redux";
// import { withStyles } from "@material-ui/core/styles";
import { doLog, hasValue, notNull, updateObject } from "../../shared/utility";

import Button from "@material-ui/core/Button";
// import Card from "../../components/UI/Card/Card";
import classes from "../CrimeSubmission.css";
import confirm from "../../shared/confirm";
import * as actions from "../../store/actions/index";
import Grid from "@material-ui/core/Grid";
import Form from "../../components/UI/Form/Form";
import Logo from "../../components/Logo/Logo";
import ManageCustomText from "./ManageCustomText";
import moment from "moment";

const mappedSelectPropFields = ["COUNTY", "CITY_TOWNSHIP"];
// const mappedSelectPropFields = ["CITY_TOWNSHIP"];

const mappedTextPropFields = [
  "AGENCYCODE",
  "ORI",
  "NAME",
  "ADDRESSTEXT",
  "REQUIREREVIEW",
  "SENDINCACCEPTEDEMAIL",
  "SENDINCCOMPLETEEMAIL",
  "EMAILLIST",
  "TMAILLIST",
  "NEXTNUMBER",
  "CURRENTYEAR",
  "STARTNUMBER",
  "FBRNEXTNUMBER",
  "FBRCURRENTYEAR",
  "FBRSTARTNUMBER",
  "LOGOFILENAME",
  "LOGOPERSONNAME",
  "LOGOPERSONTITLE",
  "LOGOWIDTH",
  "LOGOHEIGHT",
  "WATERMARKTEXT",
  "FREQUENCYTYPE",
  "STARTHOUR",
  "INCIDENTPREFIX",
  "EMAILURL",
  "EMAILSUBJECT",
  "EMAILINITIALTEXT",
  "EMAILENDINGTEXT",
];
// If fields are added to this list, also update getMappedPropValue and putMappedPropValue functions

// const styles = (theme) => ({
//   root: {
//     flexGrow: 1,
//     backgroundColor: theme.palette.background.paper,
//   },
//   textField: {
//     width: 250,
//   },
//   dense: {
//     marginTop: 19,
//   },
//   spacing: 1,
// });

const gridSpacing = 0; //0 or 8 or 16 or 24 or 32 or 40
// const quote = '"';
// const singleQuote = "'";

class ManageAgency extends Form {
  state = {
    searching: false,
    editMode: true,
    timeoutSecs: 10,
    requiredFieldErrMsg: "Required fields are needed",
    keyFieldValue: null,
    //
    addAnother: false,
    //
    mappedSelectPropFields: mappedSelectPropFields,
    mappedTextPropFields: mappedTextPropFields,
    //
    AGENCYCODE: {
      inputType: "text",
      value: "",
      default: "",
      label: "Agency Code",
      maxSize: 20,
      validation: { required: true },
      upperOnly: true,
      keyField: true,
    },
    ORI: {
      inputType: "text",
      value: "",
      default: "",
      label: "ORI",
      maxSize: 9,
      validation: { required: true },
      upperOnly: true,
    },
    NAME: {
      inputType: "text",
      value: "",
      default: "",
      label: "Name",
      maxSize: 100,
      validation: { required: true },
    },
    ADDRESSTEXT: {
      inputType: "text",
      value: "",
      default: "",
      label: "Address",
      maxSize: 100,
    },
    LOGOFILENAME: {
      inputType: "text",
      value: "",
      default: "",
      label: "Logo Filename",
      maxSize: 100,
    },
    LOGOPERSONNAME: {
      inputType: "text",
      value: "",
      default: "",
      label: "Logo Person Name",
      maxSize: 50,
    },
    LOGOPERSONTITLE: {
      inputType: "text",
      value: "",
      default: "",
      label: "Logo Person Title",
      maxSize: 50,
    },
    LOGOWIDTH: {
      inputType: "number",
      value: "",
      default: "90",
      label: "Logo Width",
    },
    LOGOHEIGHT: {
      inputType: "number",
      value: "",
      default: "90",
      label: "Logo Height",
    },
    WATERMARKTEXT: {
      inputType: "text",
      value: "",
      default: "",
      label: "WaterMark Message (Optional)",
      maxSize: 50,
    },
    REQUIREREVIEW: {
      inputType: "checkbox",
      value: "N",
      default: "N",
      label: "Require a Review before sending the incident to the RMS",
      checkedValue: "Y",
      uncheckedValue: "N",
    },
    SENDINCACCEPTEDEMAIL: {
      inputType: "checkbox",
      value: "N",
      default: "N",
      label: "Send an email to the Complainant when the incident is Reviewed",
      checkedValue: "Y",
      uncheckedValue: "N",
    },
    SENDINCCOMPLETEEMAIL: {
      inputType: "checkbox",
      value: "N",
      default: "N",
      label: "Send an email to the Complainant when the Incident is Complete",
      checkedValue: "Y",
      uncheckedValue: "N",
    },
    EMAILLIST: {
      inputType: "text",
      value: "",
      default: "",
      multiline: true,
      rows: 4,
      label: "Email List",
    },
    TMAILLIST: {
      inputType: "text",
      value: "",
      default: "",
      multiline: true,
      rows: 4,
      label: "Talon Mail List",
    },
    EMAILURL: {
      inputType: "text",
      value: "",
      default: "",
      label: "eCOP URL",
      maxSize: 50,
    },
    EMAILSUBJECT: {
      inputType: "text",
      value: "",
      default: "",
      label: "Email Subject",
      maxSize: 50,
    },
    EMAILINITIALTEXT: {
      inputType: "text",
      value: "",
      default: "",
      multiline: true,
      rows: 4,
      label: "Email Initial Text",
    },
    EMAILENDINGTEXT: {
      inputType: "text",
      value: "",
      default: "",
      multiline: true,
      rows: 4,
      label: "Email Ending Text",
    },
    NEXTNUMBER: {
      inputType: "number",
      value: "1",
      default: "1",
      label: "Next Number",
    },
    STARTNUMBER: {
      inputType: "number",
      value: "1",
      default: "1",
      label: "Starting Number (Each Year)",
    },
    CURRENTYEAR: {
      inputType: "number",
      value: moment().format("YYYY"),
      default: "",
      label: "Current Year",
    },
    FBRNEXTNUMBER: {
      inputType: "number",
      value: "1",
      default: "1",
      label: "Next Number",
    },
    FBRSTARTNUMBER: {
      inputType: "number",
      value: "1",
      default: "1",
      label: "Starting Number (Each Year)",
    },
    FBRCURRENTYEAR: {
      inputType: "number",
      value: moment().format("YYYY"),
      default: "",
      label: "Current Year",
    },
    INCIDENTPREFIX: {
      inputType: "text",
      value: "",
      default: "",
      maxSize: 50,
      label: "Incident Prefix (Optional)",
    },
    COUNTY: {
      inputType: "select",
      value: null,
      label: "County",
      listName: "countyList",
      codegroup: "61",
      validation: { required: false },
      onChange: (countySelected) => {
        this.handleCountyChange(countySelected);
      },
    },
    CITY_TOWNSHIP: {
      inputType: "select",
      value: null,
      label: "City/Twp",
      listName: "citytwpList",
      codegroup: "62",
      validation: { required: false },
    },
    FREQUENCYTYPE: {
      inputType: "select",
      value: "NEVER",
      label: "Notification Frequency",
      optionList: [
        { value: "NEVER", label: "Never" },
        { value: "HOUR", label: "Hourly" },
        { value: "DAY", label: "Daily" },
        { value: "WDAY", label: "Week Days" },
        { value: "NOW", label: "Test Once Now" },
      ],
      validation: { required: false },
    },
    STARTHOUR: {
      inputType: "select",
      value: "0",
      label: "Hour",
      optionList: [
        { label: "Midnight", value: "0" },
        { label: "1am", value: "1" },
        { label: "2am", value: "2" },
        { label: "3am", value: "3" },
        { label: "4am", value: "4" },
        { label: "5am", value: "5" },
        { label: "6am", value: "6" },
        { label: "7am", value: "7" },
        { label: "8am", value: "8" },
        { label: "9am", value: "9" },
        { label: "10am", value: "10" },
        { label: "11am", value: "11" },
        { label: "Noon", value: "12" },
        { label: "1pm", value: "13" },
        { label: "2pm", value: "14" },
        { label: "3pm", value: "15" },
        { label: "4pm", value: "16" },
        { label: "5pm", value: "17" },
        { label: "6pm", value: "18" },
        { label: "7pm", value: "19" },
        { label: "8pm", value: "20" },
        { label: "9pm", value: "21" },
        { label: "10pm", value: "22" },
        { label: "11pm", value: "23" },
      ],
      validation: { required: false },
    },
    //
  };

  componentDidMount() {
    if (doLog())
      console.log("[ManageAgency] componentDidMount state:", this.state);
    if (doLog())
      console.log("[ManageAgency] componentDidMount props:", this.props);
    if (!this.props.add) {
      this.copyFieldValuesToState();
      this.props.onClearCustomTextList();
      this.props.onSetCustomTextArray([]);
      this.props.onFetchCustomTextList(
        this.props.item.AGENCYCODE,
        this.props.token
      );
    } else {
      // if (this.props.customTextList === null) {
      this.props.onFetchCustomTextList("DEFAULTDATA", this.props.token);
      // }
    }
  }

  componentDidUpdate() {
    if (doLog())
      console.log("[ManageAgency] componentDidUpdate state:", this.state);
    if (doLog())
      console.log("[ManageAgency] componentDidUpdate props:", this.props);
    if (
      this.state.searching &&
      this.props.error === null &&
      hasValue(this.props.result)
    ) {
      // if (doLog()) console.log("[ManageAgency] componentDidUpdate result:", this.props.result);
      // if (doLog()) console.log(
      //   "[ManageAgency] componentDidUpdate transDesc:",
      //   this.props.transDesc
      // );
      this.setState({ searching: false });
      const resultMsg = this.props.result[0];
      if (
        (this.props.transDesc === "agencyWrite" ||
          this.props.transDesc === "agencyDelete") &&
        resultMsg === "Complete"
      ) {
        if (this.props.transDesc === "agencyDelete") {
          this.props.onDelete();
        }

        this.props.onClearTransDesc();
        this.props.onClearWebAgencyList();
        this.props.onClearTransactionResult();

        if (this.state.addAnother) {
          this.props.onAddAnother();
        } else {
          this.props.onCancel();
        }

        this.setState({ addAnother: false });
      }
    }
    this.getListFiles();
  }

  copyFieldValuesToState() {
    // if (doLog()) console.log("[ManageAgency]copyFieldValuesToState item:", this.props.item);
    if (this.props.item !== null) {
      const item = this.props.item;
      for (let field in this.state.mappedTextPropFields) {
        const fieldName = this.state.mappedTextPropFields[field];
        // if (doLog()) console.log("[ManageAgency]copyFieldValuesToState text field:", fieldName);
        let newValue = notNull(item[fieldName]);
        // if (doLog()) console.log(
        //   "[ManageAgency]copyFieldValuesToState text newValue:",
        //   newValue
        // );
        if (newValue === "" && fieldName === "FREQUENCYTYPE") {
          newValue = "NEVER";
        }
        this.setState({
          [fieldName]: updateObject(this.state[fieldName], {
            value: newValue,
          }),
        });
        if (this.state[fieldName].keyField === true) {
          this.setState({ keyFieldValue: item[fieldName] });
        }
      }

      for (let field in this.state.mappedSelectPropFields) {
        const fieldName = this.state.mappedSelectPropFields[field];
        // if (doLog()) console.log(
        //   "[ManageAgency]copyFieldValuesToState select field:",
        //   fieldName
        // );
        this.setState({
          [fieldName]: updateObject(this.state[fieldName], {
            value: notNull(item[fieldName]),
          }),
        });
      }
    }
  }

  getListFiles = () => {
    // if (doLog()) console.log("[ManageAgency] getListFiles ORI:", this.state.ORI.value);
    if (hasValue(this.state.ORI.value)) {
      let done = false;
      const count = this.state.mappedSelectPropFields.length;
      for (let i = 0; i < count && !done; i++) {
        const fieldName = this.state.mappedSelectPropFields[i];
        const listName = this.state[fieldName].listName;
        const codegroup = this.state[fieldName].codegroup;
        // if (doLog()) console.log("[ManageAgency] getListFiles fieldName:", fieldName);
        // if (doLog()) console.log("[ManageAgency] getListFiles listName:", listName);
        // if (doLog()) console.log("[ManageAgency] getListFiles codegroup:", codegroup);
        // if (doLog()) console.log("[ManageAgency] getListFiles list:", this.props[listName]);
        // if (doLog()) console.log("[ManageAgency] getListFiles list valid:", hasValue(this.props[listName]));
        // if (doLog()) console.log("[ManageAgency] getListFiles inprocess:", this.state[fieldName].inprocess);
        if (hasValue(codegroup)) {
          if (
            !hasValue(this.props[listName]) &&
            (hasValue(this.state[fieldName].inprocess) ||
              this.state[fieldName].inprocess === true)
          ) {
            done = true;
          } else if (
            !hasValue(this.props[listName]) &&
            (!hasValue(this.state[fieldName].inprocess) ||
              this.state[fieldName].inprocess !== true)
          ) {
            this.setState({
              [fieldName]: updateObject(this.state[fieldName], {
                inprocess: true,
              }),
            });
            let ori = this.state.ORI.value;
            if (listName === "countyList" || listName === "citytwpList")
              ori = "";
            this.props.onFetchValidCodeLists(
              ori,
              this.props.token,
              listName,
              codegroup,
              false,
              false
            );
            done = true;
          } else if (
            hasValue(this.state[fieldName].inprocess) &&
            this.state[fieldName].inprocess === true
          ) {
            // if (doLog()) console.log(
            //   "[ManageAgency] getListFiles inprocess for:",
            //   fieldName
            // );
            let citytwpOptions = null;
            if (
              fieldName === "CITY_TOWNSHIP" &&
              hasValue(this.props.citytwpList)
            ) {
              // if (doLog()) console.log("[ManageAgency] getListFiles getting options");
              citytwpOptions = [];
              const countyValue = this.state.COUNTY.value;
              for (let i = 0; i < this.props.citytwpList.length; i++) {
                const fields = this.props.citytwpList[i];
                const citytwpValue = fields.value;
                if (
                  citytwpValue.startsWith(countyValue) &&
                  hasValue(fields.label)
                ) {
                  // if (doLog()) console.log("[ManageAgency] getListFiles fields:", fields);
                  citytwpOptions.push({
                    value: fields.value,
                    label: fields.label,
                  });
                }
              }
            }

            this.setState({
              [fieldName]: updateObject(this.state[fieldName], {
                inprocess: false,
                optionList: citytwpOptions,
              }),
            });
          } else if (
            fieldName === "CITY_TOWNSHIP" &&
            hasValue(this.state.CITY_TOWNSHIP) &&
            hasValue(this.props.citytwpList) &&
            !hasValue(this.state.CITY_TOWNSHIP.optionList)
          ) {
            // if (doLog()) console.log("[ManageAgency] getListFiles getting options not in process");
            const citytwpOptions = [];
            const countyValue = this.state.COUNTY.value;
            for (let i = 0; i < this.props.citytwpList.length; i++) {
              const fields = this.props.citytwpList[i];
              const citytwpValue = fields.value;
              if (
                citytwpValue.startsWith(countyValue) &&
                hasValue(fields.label)
              ) {
                // if (doLog()) console.log("[ManageAgency] getListFiles fields:", fields);
                citytwpOptions.push({
                  value: fields.value,
                  label: fields.label,
                });
              }
            }
            this.setState({
              [fieldName]: updateObject(this.state[fieldName], {
                inprocess: false,
                optionList: citytwpOptions,
              }),
            });
          }
        }
      }
    }
  };

  handleCancelButton = () => {
    if (doLog()) console.log("[ManageAgency] handleCancelButton");
    this.props.onCancel();
  };

  handleCountyChange = (countySelected) => {
    if (doLog())
      console.log(
        "[ManageAgency] handleCountyChange countySelected:",
        countySelected
      );
    const target = countySelected.target;
    if (target.value === -1) {
      this.setState({
        COUNTY: updateObject(this.state.COUNTY, {
          value: "",
          labelValue: null,
        }),
        CITY_TOWNSHIP: updateObject(this.state.CITY_TOWNSHIP, {
          value: "",
          labelValue: null,
        }),
      });
    } else {
      const obj = this.props.countyList.find(
        (option) => option.value === target.value
      );
      const citytwpOptions = [];
      for (let i = 0; i < this.props.citytwpList.length; i++) {
        const fields = this.props.citytwpList[i];
        const citytwpValue = fields.value;
        if (citytwpValue.startsWith(target.value) && hasValue(fields.label)) {
          // if (doLog()) console.log("[ManageAgency] handleCountyChange fields:", fields);
          citytwpOptions.push({ value: fields.value, label: fields.label });
        }
      }
      // if (doLog()) console.log("[ManageAgency] handleCountyChange citytwpOptions", citytwpOptions);
      if (doLog()) console.log("[ManageAgency] handleCountyChange obj", obj);
      this.setState({
        COUNTY: updateObject(this.state.COUNTY, {
          value: target.value,
          labelValue: obj.label,
        }),
        CITY_TOWNSHIP: updateObject(this.state.CITY_TOWNSHIP, {
          value: citytwpOptions[0].value,
          labelValue: citytwpOptions[0].name,
          optionList: citytwpOptions,
        }),
      });
    }
  };

  handleDeleteButton = () => {
    if (doLog()) console.log("[ManageAgency] handleDeleteButton");
    confirm("Are you sure you want to delete?", {
      title: "Delete Agency",
      okLabel: "Yes",
    }).then(
      (result) => {
        if (doLog()) console.log("delete confirmed");
        const transactionType = "CitizenAgencyDelete";
        const data = {
          agencyCode: this.state.AGENCYCODE.value,
          ori: this.state.ORI.value,
        };
        const request = {
          transactionType,
          data,
        };

        if (doLog())
          console.log("[ManageAgency] handleDeleteButton request:", request);
        this.setState({ searching: true });
        this.props.onRunTransaction(request, this.props.token, "agencyDelete");
        // this.props.onDelete();
      },
      (result) => {
        if (doLog()) console.log("delete cancelled");
        if (doLog()) console.log(result);
      }
    );
  };

  handleFileSelection = (event) => {
    if (doLog()) console.log("[ManageAgency] handleFileSelection event", event);
    if (doLog())
      console.log(
        "[ManageAgency] handleFileSelection files",
        event.target.files
      );
    event.preventDefault();

    if (event.target.files !== null && event.target.files.length > 0) {
      const fileName = event.target.files[0].name;

      let file = event.target.files[0];
      if (file.type.startsWith("image")) {
        let reader = new FileReader();
        reader.onloadend = () => {
          this.setState({
            selectedFile: file,
            LOGOFILENAME: updateObject(this.state.LOGOFILENAME, {
              value: fileName,
            }),
            selectedPreviewUrl: reader.result,
          });
        };

        reader.readAsDataURL(file);
      }
    }
  };

  handleNewManageCustomText = (index, fields) => {
    if (doLog())
      console.log("[ManageAgency]handleNewManageCustomText index:", index);
    if (doLog())
      console.log(
        "[ManageAgency]handleNewManageCustomText customTextArray:",
        this.props.customTextArray
      );
    if (doLog())
      console.log("[ManageAgency]handleNewManageCustomText fields:", fields);
    // this.props.onAddToCustomTextArray(this.props.customTextArray, fields);
    this.props.onAddToCustomTextArray(fields);
  };

  handleSubmitAddButton = () => {
    if (doLog()) console.log("[ManageAgency] handleAddButton");
    this.issueSubmit();
    this.props.onClearCustomTextList();
    this.setState({ addAnother: true });
  };

  handleSubmitButton = () => {
    if (doLog())
      console.log("[ManageAgency] handleSubmitButton add:" + this.props.add);
    this.issueSubmit();
    this.setState({ addAnother: false });
  };

  issueSubmit = () => {
    let customTextData = [];
    if (
      hasValue(this.props.customTextArray) &&
      this.props.customTextArray.length > 0
    ) {
      for (let i = 0; i < this.props.customTextArray.length; i++) {
        const array = this.props.customTextArray[i];
        if (array !== null) {
          const fields = {
            agencyCode: this.state.AGENCYCODE.value, //get any change to the agencyCode
            textLocation: array.TEXTLOCATION.value,
            customText: array.CUSTOMTEXT.value,
          };
          customTextData.push(fields);
        }
      }
    }

    const transactionType = "CitizenAgencyWrite";
    const data = {
      agencyCode: this.state.AGENCYCODE.value,
      ori: this.state.ORI.value,
      name: this.state.NAME.value,
      addressText: this.state.ADDRESSTEXT.value,
      requireReview: this.state.REQUIREREVIEW.value,
      sendIncAcceptedEmail: this.state.SENDINCACCEPTEDEMAIL.value,
      sendIncCompleteEmail: this.state.SENDINCCOMPLETEEMAIL.value,
      emailList: this.state.EMAILLIST.value,
      tmailList: this.state.TMAILLIST.value,
      emailURL: this.state.EMAILURL.value,
      emailSubject: this.state.EMAILSUBJECT.value,
      emailInitialText: this.state.EMAILINITIALTEXT.value,
      emailEndingText: this.state.EMAILENDINGTEXT.value,
      nextNumber: this.state.NEXTNUMBER.value,
      currentYear: this.state.CURRENTYEAR.value,
      startNumber: this.state.STARTNUMBER.value,
      fbrNextNumber: this.state.FBRNEXTNUMBER.value,
      fbrCurrentYear: this.state.FBRCURRENTYEAR.value,
      fbrStartNumber: this.state.FBRSTARTNUMBER.value,
      incidentPrefix: this.state.INCIDENTPREFIX.value,
      logoFileName: this.state.LOGOFILENAME.value,
      logoPersonName: this.state.LOGOPERSONNAME.value,
      logoPersonTitle: this.state.LOGOPERSONTITLE.value,
      logoWidth: this.state.LOGOWIDTH.value,
      logoHeight: this.state.LOGOHEIGHT.value,
      waterMarkText: this.state.WATERMARKTEXT.value,
      county: this.state.COUNTY.value,
      citytwp: this.state.CITY_TOWNSHIP.value,
      frequencyType: this.state.FREQUENCYTYPE.value,
      startHour: this.state.STARTHOUR.value,
      //
      customTextData: customTextData,
    };
    const request = {
      transactionType,
      data,
    };

    if (doLog()) console.log("[ManageAgency] issueSubmit request:", request);
    this.setState({ searching: true });
    this.props.onRunTransaction(request, this.props.token, "agencyWrite");
    if (hasValue(this.state.selectedPreviewUrl)) {
      this.submitLogo();
    }
  };

  submitLogo = () => {
    const formData = new FormData();
    formData.append("incidentID", "");
    formData.append("ori", "");
    formData.append("file", this.state.selectedFile);
    formData.append("fileName", this.state.LOGOFILENAME.value);
    formData.append("title", "");
    formData.append("transactionName", "ciddb");
    formData.append("transactionType", "AddCitizenLogoFile");

    if (doLog())
      console.log(
        "[ManageAgency] submitLogo LOGOFILENAME:",
        this.state.selectedFile.value
      );
    this.props.onUpLoadFile(formData, this.props.token, 0);
  };

  render() {
    if (doLog()) console.log("[ManageAgency]render item:", this.props.item);
    const editType = this.props.add ? "Add" : "Edit";
    const informationSection = (
      <p className={classes.Information}>
        {editType} Agency: {this.props.item.NAME}
      </p>
    );

    let countySection = null;
    if (hasValue(this.props.item.ORI))
      if (doLog())
        console.log("[ManageAgency]render ORI:", this.props.item.ORI);
    if (
      hasValue(this.props.item.ORI) &&
      this.props.item.ORI.startsWith("MI") &&
      hasValue(
        this.props.countyList && hasValue(this.state.CITY_TOWNSHIP.optionList)
      )
    ) {
      countySection = (
        <Fragment>
          <Grid item xs={12}>
            <hr />
          </Grid>
          <Grid item xs={4}>
            {this.getFormField("COUNTY", false, true)}
          </Grid>
          <Grid item xs={4}>
            {this.getFormField("CITY_TOWNSHIP", false, true)}
          </Grid>
          <Grid item xs={4} />
        </Fragment>
      );
    }

    let trackingNumberSection = (
      <Fragment>
        <Grid item xs={12}>
          <hr />
        </Grid>
        <Grid item xs={12}>
          <p>Tracking Number Configuration</p>
        </Grid>
        <Grid item xs={3}>
          {this.getFormField("CURRENTYEAR", false, true)}
        </Grid>
        <Grid item xs={3}>
          {this.getFormField("STARTNUMBER", false, true)}
        </Grid>
        <Grid item xs={3}>
          {this.getFormField("NEXTNUMBER", false, true)}
        </Grid>
        <Grid item xs={3}>
          {this.getFormField("INCIDENTPREFIX", false, true)}
        </Grid>
        <Grid item xs={3}>
          {this.getFormField("FBRCURRENTYEAR", false, false)}
        </Grid>
        <Grid item xs={3}>
          {this.getFormField("FBRSTARTNUMBER", false, false)}
        </Grid>
        <Grid item xs={3}>
          {this.getFormField("FBRNEXTNUMBER", false, false)}
        </Grid>
        <Grid item xs={3}>
          <p>FBR</p>
        </Grid>
      </Fragment>
    );

    let reviewSection = null;
    let hourField = null;
    if (this.state.REQUIREREVIEW.value === "Y") {
      if (
        this.state.FREQUENCYTYPE.value === "DAY" ||
        this.state.FREQUENCYTYPE.value === "WDAY"
      ) {
        hourField = this.getFormField("STARTHOUR", false, true);
      }
      reviewSection = (
        <Fragment>
          <Grid item xs={12}>
            <p>
              If a notification to agency personnel is desired when there are
              incidents to be reviewed, enter their Email or Talon Mail
              addresses below.
            </p>
            <p>
              The format is a comma separated list of agency personnel's email
              or Talon Mail addresses (username@multibridgename).{" "}
            </p>
          </Grid>
          <Grid item xs={12}>
            {this.getFormField("EMAILLIST", false, true)}
          </Grid>
          <Grid item xs={12}>
            {this.getFormField("TMAILLIST", false, true)}
          </Grid>
          <Grid item xs={4}>
            {this.getFormField("FREQUENCYTYPE", false, true)}
          </Grid>
          <Grid item xs={4}>
            {hourField}
          </Grid>
          <Grid item xs={4} />
          {/* <Grid item xs={12}>
            <hr />
          </Grid>
          <Grid item xs={6}>
            {this.getFormField("SENDINCACCEPTEDEMAIL", false, true)}
          </Grid>
          <Grid item xs={6}>
            {this.getFormField("SENDINCCOMPLETEEMAIL", false, true)}
          </Grid> */}
        </Fragment>
      );
    }

    let moreInfoSection = (
      <Fragment>
        <Grid item xs={12}>
          <hr />
        </Grid>
        <Grid item xs={12}>
          <p>Customize the text for emails sent requesting more information</p>
        </Grid>
        <Grid item xs={12}>
          {this.getFormField("EMAILURL", false, true)}
        </Grid>
        <Grid item xs={12}>
          {this.getFormField("EMAILSUBJECT", false, true)}
        </Grid>
        <Grid item xs={12}>
          {this.getFormField("EMAILINITIALTEXT", false, true)}
        </Grid>
        <Grid item xs={12}>
          {this.getFormField("EMAILENDINGTEXT", false, true)}
        </Grid>
      </Fragment>
    );

    let customTextSection = null;
    if (hasValue(this.props.customTextList)) {
      const customTextArray = [];
      const array = this.props.customTextList;
      for (let i = 0; i < array.length; i++) {
        const item = array[i].data;
        customTextArray.push(
          <ManageCustomText
            key={i}
            index={i}
            item={item}
            onNewControl={this.handleNewManageCustomText.bind(this)}
          />
        );
      }
      customTextSection = (
        <Fragment>
          <Grid item xs={12}>
            <hr />
          </Grid>
          <Grid item xs={12}>
            <p>Customize the Web Page Text</p>
          </Grid>
          {customTextArray}
        </Fragment>
      );
    }

    let deleteAndAddAnotherButton = null;
    if (this.props.modulePermissions.allowedAgencyCode === "ALL") {
      deleteAndAddAnotherButton = (
        <Fragment>
          &nbsp;&nbsp;
          <Button
            variant="contained"
            //color="default"
            color="primary"
            size="small"
            onClick={this.handleSubmitAddButton.bind(this)}
          >
            Submit/Add Another
          </Button>
          &nbsp;&nbsp;
          <Button
            variant="contained"
            //color="default"
            color="primary"
            size="small"
            onClick={this.handleDeleteButton.bind(this)}
          >
            Delete
          </Button>
        </Fragment>
      );
    }

    let selectButtonSection = (
      <Fragment>
        <p className={classes.EmptyLabel}>&nbsp;</p>
        <p className={classes.EmptyLabel}>&nbsp;</p>
        <Button
          variant="contained"
          color="primary"
          component="label"
          size="small"
        >
          Select a new logo file
          <input
            hidden
            accept="image/*"
            type="file"
            onChange={this.handleFileSelection}
          />
        </Button>
      </Fragment>
    );

    let logoSection = null;
    if (this.state.LOGOFILENAME.value.length > 0) {
      let baseURL = "";
      //let pathname = "";
      const appPath = "/ecop";
      const logoFilePath = "/images/";
      let logoPath = "";
      let logoName = "";
      let logoWidth = 0;
      let logoHeight = 0;
      baseURL = this.props.baseURL;
      //pathname = this.props.pathname;
      logoName = this.state.LOGOFILENAME.value;
      logoWidth = this.state.LOGOWIDTH.value;
      logoHeight = this.state.LOGOHEIGHT.value;
      if (hasValue(this.state.selectedPreviewUrl)) {
        logoPath = this.state.selectedPreviewUrl;
      } else {
        // if (pathname.startsWith(appPath)) {
        //   logoPath = baseURL + pathname + logoFilePath + logoName;
        // } else {
        //   logoPath = baseURL + appPath + pathname + logoFilePath + logoName;
        // }
        logoPath = baseURL + appPath + logoFilePath + logoName;
      }
      if (doLog()) console.log("[ManageAgency] logoName:", logoName);
      if (doLog()) console.log("[ManageAgency] logoPath:", logoPath);
      if (doLog()) console.log("[ManageAgency] logoWidth:", logoWidth);

      if (hasValue(logoName) && logoName.length > 0) {
        logoSection = (
          <Grid item xs={12} className={classes.HeaderTitle}>
            <p>
              <Logo
                logoPath={logoPath}
                logoWidth={logoWidth}
                logoHeight={logoHeight}
              />
            </p>
          </Grid>
        );
      }
    }

    return (
      <Grid container item className={classes.Card} spacing={gridSpacing}>
        {informationSection}
        <Grid item xs={12}>
          <hr />
        </Grid>
        <Grid item xs={4}>
          {this.getFormField("AGENCYCODE", false, true)}
        </Grid>
        <Grid item xs={4}>
          {this.getFormField("ORI", false, true)}
        </Grid>
        <Grid item xs={4} />
        <Grid item xs={12}>
          {this.getFormField("NAME", false, true)}
        </Grid>
        <Grid item xs={12}>
          {this.getFormField("ADDRESSTEXT", false, true)}
        </Grid>
        <Grid item xs={12}>
          <hr />
        </Grid>
        <Grid item xs={4}>
          {this.getFormField("LOGOFILENAME", false, true)}
        </Grid>
        <Grid item xs={4}>
          {selectButtonSection}
        </Grid>
        <Grid item xs={4} />
        <Grid item xs={3}>
          {this.getFormField("LOGOWIDTH", false, true)}
        </Grid>
        <Grid item xs={3}>
          {this.getFormField("LOGOHEIGHT", false, true)}
        </Grid>
        <Grid item xs={6} />
        {logoSection}
        {/* <Grid item xs={12}>
          {this.getFormField("LOGOPERSONNAME", false, true)}
        </Grid>
        <Grid item xs={12}>
          {this.getFormField("LOGOPERSONTITLE", false, true)}
        </Grid> */}
        <Grid item xs={12}>
          <hr />
        </Grid>
        <Grid item xs={12}>
          {this.getFormField("WATERMARKTEXT", false, true)}
        </Grid>
        {countySection}
        {trackingNumberSection}
        <Grid item xs={12}>
          <hr />
        </Grid>
        <Grid item xs={12}>
          {this.getFormField("REQUIREREVIEW", false, true)}
        </Grid>
        {reviewSection}
        {moreInfoSection}
        {customTextSection}
        <Grid item xs={12}>
          <Button
            variant="contained"
            //color="default"
            color="primary"
            size="small"
            onClick={this.handleSubmitButton.bind(this)}
          >
            Submit
          </Button>
          {deleteAndAddAnotherButton}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <Button
            variant="contained"
            //color="default"
            color="primary"
            size="small"
            onClick={this.handleCancelButton.bind(this)}
          >
            Cancel
          </Button>
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  if (doLog()) console.log("[ManageAgency] mapStateToProps state:", state);
  return {
    loading: state.trans.loading,
    error: state.trans.error,
    //
    customTextArray: state.trans.customTextArray,
    customTextList: state.trans.customTextList,
    //
    modulePermissions: state.auth.modulePermissions,
    //
    result: state.trans.result,
    transDesc: state.trans.transDesc,
    //
    countyList: state.trans.countyList,
    citytwpList: state.trans.citytwpList,
    //
    baseURL: state.trans.baseURL,
    pathname: state.trans.pathname,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onRunTransaction: (options, token, transDesc) =>
      dispatch(actions.runTransaction(options, token, transDesc)),
    onClearWebAgencyList: () => dispatch(actions.clearWebAgencyList()),
    onClearTransactionResult: () => dispatch(actions.clearTransactionResult()),
    onClearTransDesc: () => dispatch(actions.clearTransDesc()),
    onClearCustomTextList: () => dispatch(actions.clearCustomTextList()),
    onFetchCustomTextList: (agencyCode, token) =>
      dispatch(actions.fetchCustomTextList(agencyCode, token)),
    onAddToCustomTextArray: (item) =>
      dispatch(actions.addToCustomTextArray(item)),
    onSetCustomTextArray: (customTextArray) =>
      dispatch(actions.setCustomTextArray(customTextArray)),
    onFetchValidCodeLists: (
      ori,
      token,
      listName,
      codeGroup,
      allFields,
      includeInactive
    ) =>
      dispatch(
        actions.fetchValidCodeLists(
          ori,
          token,
          listName,
          codeGroup,
          allFields,
          includeInactive
        )
      ),
    onUpLoadFile: (formData, token, index) =>
      dispatch(actions.upLoadFile(formData, token, index)),
    onClearUpLoadResult: () => dispatch(actions.clearUpLoadResult()),
  };
};

// export default withStyles(styles)(
//   connect(mapStateToProps, mapDispatchToProps)(ManageAgency)
// );
export default connect(mapStateToProps, mapDispatchToProps)(ManageAgency);
